import { useRef } from "react";
import {
  StyledWhatIs,
  StyledWhatIsMain,
  HeadingWhatIs,
  VideoWhatIs,
  TextWrapper,
} from "./styles/StyledWhatIs";
import { CircleItem } from "./styles/StyledInspiration";
import play from "../../../../shared/assets/img/love/love-play.svg";
import posterImg from "../../../../shared/assets/img/posters/pic_b3_1.jpg";
import videoThird from '../../../../shared/assets/video/circle/last_circle.mp4';
import { useTranslation } from 'react-i18next';

const WhatIs = () => {
  const { t, i18n } = useTranslation();
  const videoRef = useRef(null);

  const handleMouseEnter = () => {
    if (videoRef.current) {
      // @ts-ignore
      videoRef.current.play();
    }
  };

  const handleMouseLeave = () => {
    if (videoRef.current) {
      // @ts-ignore
      videoRef.current.pause();
      // @ts-ignore
      videoRef.current.currentTime = 0;
    }
  };

  const handleClick = () => {
    window.open(t('link_4'),'_blank');
    return null;
  };

  return (
    <StyledWhatIsMain>
      <h2>{t('whatis_title_1')}</h2>
      <p>{t('whatis_desc_1_5')}</p>
      <StyledWhatIs>
        <HeadingWhatIs>
          <ul>
            <li>{t('whatis_desc_1')} <a href='https://en.wikipedia.org/wiki/Polygon_(blockchain)' target='_blank'>Polygon</a></li>
            <li>{t('whatis_desc_1_1')}</li>
            <li><a href='https://en.wikipedia.org/wiki/Non-fungible_token' target='_blank'>NFT</a> {t('whatis_desc_1_2')}</li>
            <li>{t('whatis_desc_1_3')}</li>
            <li>{t('whatis_desc_1_4')}</li>
          </ul>
        </HeadingWhatIs>
        <VideoWhatIs>
          <CircleItem
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onClick={handleClick}
          >
            <video
              ref={videoRef}
              src={videoThird}
              muted
              loop
              playsInline
              poster={posterImg}
            ></video>
            <img src={play} alt="Play icon" />
          </CircleItem>
          <TextWrapper>
            <h4>{t('whatis_title_2')}</h4>
            <span>{t('whatis_desc_2')}</span>
          </TextWrapper>
        </VideoWhatIs>
      </StyledWhatIs>
    </StyledWhatIsMain>
  );
};

export default WhatIs;
